var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9981 4.65002C7.21812 4.65002 3.32812 8.54002 3.32812 13.32C3.32812 18.1 7.21812 22 11.9981 22C16.7781 22 20.6681 18.11 20.6681 13.33C20.6681 8.55002 16.7781 4.65002 11.9981 4.65002ZM12.7481 13C12.7481 13.41 12.4081 13.75 11.9981 13.75C11.5881 13.75 11.2481 13.41 11.2481 13V8.00002C11.2481 7.59002 11.5881 7.25002 11.9981 7.25002C12.4081 7.25002 12.7481 7.59002 12.7481 8.00002V13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.5720457e5ad2fe067ca93800d227af65.svg";
export { ForwardRef as ReactComponent };